export default __webpack_public_path__ + "static/stefan-chiriacescu-14c5b62145a5051d81f038c1f40b0f8c.svg";